import { render, staticRenderFns } from "./WorkOrderList.vue?vue&type=template&id=27f97178&scoped=true"
import script from "./WorkOrderList.vue?vue&type=script&lang=js"
export * from "./WorkOrderList.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderList.vue?vue&type=style&index=0&id=27f97178&prod&lang=css"
import style1 from "./WorkOrderList.vue?vue&type=style&index=1&id=27f97178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f97178",
  null
  
)

export default component.exports